import type { OutboundMessage } from './protocol'

const STORAGE_KEY = 'axg-pending-messages'
const MAX_QUEUE_SIZE = 50

export interface QueuedMessage {
  outbound: OutboundMessage
  queuedAt: number
}

export function loadQueue(): QueuedMessage[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const parsed: unknown = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    return parsed as QueuedMessage[]
  } catch {
    return []
  }
}

export function saveQueue(queue: QueuedMessage[]): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(queue))
}

export function enqueue(msg: OutboundMessage): void {
  const queue = loadQueue()
  // Dedup by messageId
  if (queue.some((q) => q.outbound.messageId === msg.messageId)) return
  queue.push({ outbound: msg, queuedAt: Date.now() })
  // FIFO: drop oldest if over max
  while (queue.length > MAX_QUEUE_SIZE) queue.shift()
  saveQueue(queue)
}

export function dequeue(messageId: string): void {
  const queue = loadQueue().filter((q) => q.outbound.messageId !== messageId)
  saveQueue(queue)
}

export function clearQueue(): void {
  localStorage.removeItem(STORAGE_KEY)
}
